'use client';

import type { FC, ReactNode } from 'react';

import { ButtonClose } from '@/components/buttons';
import { ImageComponent } from '@/components/Image';
import { usePopupHeight } from '@/hooks/usePopupHeight';

import { ScPromoSnackbar } from './styled';

interface PromoSnackbarProps {
  icon: string;
  content: ReactNode;
  onClose: () => void;
}

export const PromoSnackbar: FC<PromoSnackbarProps> = ({
  icon,
  content,
  onClose,
}) => {
  const { popupHeight } = usePopupHeight();

  return (
    <ScPromoSnackbar popupHeight={popupHeight}>
      <div className="content">
        <ImageComponent alt="promo icon" height={24} src={icon} width={24} />
        <p>{content}</p>
      </div>
      <ButtonClose onClick={onClose} right={0} top={-4} />
    </ScPromoSnackbar>
  );
};
